            
<template>
	<modal id="termsConditions" isLarge="true">
		<template slot="title" class="title">Payment Terms and Conditions</template>
		<template slot="body">
			<div class="row content">
				<div class="col-sm-12 padding">
					<label>This website is maintained by ConstellationMutual.com and its subsidiaries’ or businesses operating under the Constellation portfolio of brands, including, but not limited to, MMIC Insurance, Inc., UMIA Insurance, Inc., Arkansas Mutual Insurance Company and InsureCAREteams™, a product of MMIC Insurance, Inc., and UMIA Insurance, Inc., (collectively “Constellation, “us”, “our”, “site”, “website”, or “we”). All payments are managed with a PCI/DSS-compliant payment process service to which Constellation subscribes and Constellation does not process or store your payment card number. Constellation does not view, collect or retain your payment card information.</label>
				</div>
				<div class="col-sm-12 padding">
					<label>This payment is for coverage with InsureCAREteams, a product of MMIC Insurance, Inc., and UMIA Insurance, Inc. Your billing statement will indicate payment to MMIC Insurance, Inc. for this coverage.</label>
				</div>
				<div class="col-sm-12 padding">
					<label>Your receipt will be emailed to the primary email address indicated on your application.</label>
				</div>
				<div class="col-sm-12 padding">
					<label>You will be able to view your policy documents and modify your payment method on your InsureCAREteams dashboard.</label>
				</div>
				<div class="col-sm-12 padding">
					<label>For your convenience, your coverage will automatically renew. Your card will be charged and your policy will stay in effect. We will notify you by email prior to your card being charged.</label>
				</div>
				<div class="col-sm-12 padding">
					<label>For any policy changes, please contact us directly at 888-928-8299 or support@InsureCAREteams.com.</label>
				</div>
				<div class="col-sm-12 padding">
					<label>You can cancel your policy at any time, and we will refund the portion of your premium that you are due back. Call us at 888-928-8299 or email us at support@InsureCAREteams.com to cancel.</label>
				</div>
				<div class="col-sm-12 padding">
					<label>For policy coverage and payment questions related to InsureCAREteams, contact us at: support@InsureCAREteams.com
						<br>888-928-8299
						<br>7701 France Avenue South, Suite 500, Minneapolis, MN 55435-5288
					</label>
				</div>
			</div>
		</template>
		<template slot="footer">
			<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
		</template>
	</modal>
</template>

<script>
import Modal from './Base.vue';

export default {
	name: 'TermsConditions',
	components: {
		Modal,
	},
};
</script>
<style lang="scss" scoped>
.title {
	font-size: 20px;
	font-family: Roboto;
	line-height: 24px;
}
.content {
	font-size: 16px;
	font-family: Roboto;
	line-height: 30px;
}
.padding {
	padding-top: 25px;
}
.highlight {
	color: #3ea7c6;
}
</style>